<template>
  <div class="flex flex-col gap-5 items-center">
    <p class="text-center">{{ props.text }}</p>
    <div class="py-50px">
      <etg-img class="w-131px h-142px" src="@/assets/images/table-crying.svg" />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  text: string
}

const props = defineProps<Props>()
</script>
